import { Fragment } from 'react';
import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';

import { showAdditionalFields } from './helpers';

const EmailFormFields = (props) => {
  const { fields } = props;
  const addField = (e) => {
    e.preventDefault();
    // Need to push an extra one if there isn't one on the stack
    if (fields.length === 0) {
      fields.push({});
    }
    fields.push({});
  };
  return (
    <>
      {renderArray(fields)}
      {renderAdditionalEmails(fields, addField)}
    </>
  );
};

const renderAdditionalEmails = (fields, addField) => {
  const shouldShowAdditional = showAdditionalFields(fields, 'email');

  if (!shouldShowAdditional) {
    return null;
  }

  return (
    <div>
      <a className="c7-button-small" onClick={addField}>
        Add Additional Email
      </a>
    </div>
  );
};

const renderArray = (fields) => {
  if (fields.length <= 1) {
    return (
      <Field
        name="emails[0].email"
        component={TextField}
        autocomplete="email"
        label="Email"
        type="email"
        required
      />
    );
  }
  return fields.map((email, index) => (
    <Fragment key={email}>
      {index === 0 && (
        <Field
          name={`${email}.email`}
          component={TextField}
          autocomplete="email"
          label="Email"
          type="email"
          required
        />
      )}
      {index !== 0 && (
        <Field
          name={`${email}.email`}
          component={TextField}
          label="Additional Email"
          autocomplete="email"
          type="email"
          actionButton={renderDeleteButton(fields, index)}
        />
      )}
    </Fragment>
  ));
};

const renderDeleteButton = (fields, index) => (
  <a
    className="c7-button-alt-small"
    onClick={(e) => {
      e.preventDefault();
      fields.remove(index);
    }}
  >
    Delete
  </a>
);

export default EmailFormFields;
